import { render } from "./Projects.vue?vue&type=template&id=d52c016e&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=d52c016e&lang=scss&scoped=true"

import exportComponent from "/Users/johlmike/Documents/02.接案/精準營養管理資訊系統/isopnm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52c016e"]])

export default __exports__